import React, { useState } from 'react';
import { ICON_NEW } from '../extras/icons';
import MainContent from '../layout/MainContent';
import RecuseList from './recuses/RecuseList';
import RecuseForm from './recuses/RecuseForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addRecusesAction } from '../../actions/recusesActions';
import AuthoritiesService from '../../services/AuthoritiesService';
import { PARAMETROS_CREAR, RECUSACIONES_CREAR } from '../../data/objects';
//Función principal
const Recuses = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addRecusesAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, RECUSACIONES_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Recusaciones' 
                subtitle='Utilidades' 
                nodes={nodes}
                actions={actions}
                component={RecuseList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <RecuseForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default Recuses;